import { Shimmer } from "components/shimmer";
import { Card, CardContent } from "ui/components/card";

export function EvtStatsCardLoader() {
  return (
    <Card className="rounded-xl">
      <CardContent className="flex flex-col gap-2 md:gap-3 ">
        <Shimmer className="w-24 h-8" />
        <Shimmer className="w-16 h-7" />
      </CardContent>
    </Card>
  );
}
